import React from 'react';
import rbcLogo from '../assets/images/rbc-foundation-logo.png';

// RBC Foundation funding attribution (required by the grant agreement):
// name + logo on the site, plus the "solely responsible" disclaimer where practical.
// The logo sits on a white chip so the blue artwork stays legible in dark mode.

const Logo: React.FC<{ className: string }> = ({ className }) => (
  <span className="inline-flex shrink-0 items-center rounded-md bg-white px-2 py-1">
    <img src={rbcLogo} alt="RBC Foundation" className={className} />
  </span>
);

/** Short attribution + logo, used at the bottom of the login page. */
export const RbcAttributionShort: React.FC = () => (
  <div className="flex items-center justify-center gap-3 text-sm text-muted-foreground">
    <Logo className="h-7 w-auto" />
    <span>This project was supported by RBC Foundation.</span>
  </div>
);

/** App-wide footer: short text, disclaimer and logo. */
export const RbcAttributionFooter: React.FC = () => (
  <footer className="flex shrink-0 flex-wrap items-center justify-center gap-x-4 gap-y-1 border-t border-border bg-[var(--surface)] px-4 py-2 text-xs text-muted-foreground">
    <Logo className="h-5 w-auto" />
    <span>
      This project was supported by RBC Foundation. While financially supported by RBC Foundation,
      NatureScan is solely responsible for all content.
    </span>
  </footer>
);
